/**
 * @title Api Documentation
 * @description Api Documentation
 * @version 1.0
 *
 * Swagger version 2.0
 * Generated at: Thu Apr 15 2021 13:12:14 GMT+0200 (czas środkowoeuropejski letni)
 */

import { API_URLS } from '../utils/config';
import { request } from '../utils/request';
import prepareQueryParams from 'utils/prepareQueryParams';

const URL = API_URLS.SUPPLIER_INVOICE;

export interface AbstractResponse<D, L> {
  code: string;
  data: D;
  description: string;
  list: Array<L>;
  message: string;
}

export interface CreateSInvoiceFileParams {
  mgid: number;
  tpidsupplier: number;
  currcode: string;
  cipaystatus: string;
  startdate: string;
  enddate: string;
  ctetype: string;
  ctedirection: string;
  servcode: string;
}

export function createSInvoiceFile(params: CreateSInvoiceFileParams) {
  return request.post<JobExecutionResponse>(
    `${URL}/api/run/createSIFile` +
      prepareQueryParams({
        mgid: params.mgid,
        tpidSupplier: params.tpidsupplier,
        startdate: params.startdate,
        enddate: params.enddate,
        currcode: params.currcode,
        cipaystatus: params.cipaystatus,
        ctetype: params.ctetype,
        ctedirection: params.ctedirection,
        servcode: params.servcode,
      } as any)
  );
}

export interface SIListResponse {
  sistatuslabel: string;
  sitypelabel: string;
  clientname: string;
  ctreference: string;
  currcode: string;
  deliveryreference: string;
  mgid: number;
  orderreference: string;
  sidocdate: string;
  sidocreference: string;
  sidueamount: number;
  sigrosstotal: number;
  siid: number;
  siidcreditnote: number;
  sireference: string;
  sistatus: string;
  sitype: string;
  suppliername: string;
  tprefclient: string;
  tprefsupplier: string;
}

export interface SIScheduleListResponse {
  clientname: string;
  ctreference: string;
  currcode: string;
  deliveryreference: string;
  mgid: number;
  orderreference: string;
  sidocdate: string;
  sidocreference: string;
  sidueamount: number;
  sigrosstotal: number;
  siid: number;
  siidcreditnote: number;
  sireference: string;
  sisamount: number;
  sisdueamount: number;
  sisduedate: string;
  sisid: number;
  sisorder: number;
  sispaymentmode: string;
  sisstatus: string;
  sistatus: string;
  sistype: string;
  sitype: string;
  suppliername: string;
  tpidbeneficiary: number;
  tprefclient: string;
  tprefsupplier: string;
}

export interface SuppInvoiceLineRequest {
  assetid: number;
  compid: number;
  ctrid: number;
  siid: number;
  sfid: number;
  psid:number;
  silcategory: string;
  sildescription: string;
  sildescription2: string;
  sildiscountperc: number;
  silgrosstotalamount: number;
  silid: number;
  silnettotalamount: number;
  silnetunitamountafterd: number;
  silnetunitmount: number;
  silorder: number;
  silquantity: number;
  siltaxcode: string;
  siltaxrate: number;
  siltaxtotalamount: number;
  siltype: string;
}

export interface SuppInvoiceLineResponse {
  assetid: number;
  compid: number;
  ctrid: number;
  siid: number;
  psid:number;
  sfid:number;
  silcategory: string;
  sildescription: string;
  sildescription2: string;
  sildiscountperc: number;
  silgrosstotalamount: number;
  silid: number;
  silnettotalamount: number;
  silnetunitamountafterd: number;
  silnetunitmount: number;
  silorder: number;
  silquantity: number;
  siltaxcode: string;
  siltaxrate: number;
  siltaxtotalamount: number;
  siltype: string;
}

export interface SuppInvoiceScheduleRequest {
  mgbankaccount: number;
  sisamount: number;
  sisdueamount: number;
  sisduedate: string;
  sisid: number;
  sisorder: number;
  sispaymentdelaycode: string;
  sispaymentmode: string;
  sispercentage: number;
  sisstatus: string;
  sistype: string;
  tpbeneficiarybankaccount: string;
  tpidbeneficiary: number;
  tpbkid: number;
  siscategory: string;
  sislabel: string;
}

export interface SuppInvoiceScheduleResponse {
  mgbankaccount: number;
  sisamount: number;
  sisdueamount: number;
  sisduedate: string;
  sisid: number;
  sisorder: number;
  sispaymentdelaycode: string;
  sispaymentmode: string;
  sispercentage: number;
  sisstatus: string;
  sistype: string;
  tpbkid: number;
  tpbeneficiarybankaccount: string;
  tpidbeneficiary: number;
  siscategory: string;
  sislabel: string;
}

export interface SupplierInvoiceRequest {
  accountingdate: string;
  accountingreference: string;
  ctreference: string;
  ctrid: number;
  currcode: string;
  deliverydate: string;
  deliveryreference: string;
  mgid: number;
  orderdate: string;
  orderreference: string;
  sicomplevel: boolean;
  sidocdate: string;
  sidocreference: string;
  sidueamount: number;
  sigrosstotal: number;
  siid: number;
  siidcreditnote: number;
  simultiplecontracts: boolean;
  sinettotal: number;
  sipaymentdate: string;
  sipaymentdelaycode: string;
  sipaymentmode: string;
  sireference: string;
  sistatus: string;
  sitaxtotal: number;
  sitype: string;
  suppInvoiceLines: Array<SuppInvoiceLineRequest>;
  suppInvoiceSchedules: Array<SuppInvoiceScheduleRequest>;
  tpdeliveryaddress: string;
  tpdeliveryaddress2: string;
  tpdeliverycity: string;
  tpdeliveryzipcode: string;
  tpidclient: number;
  tpidsupplier: number;
  tpinvoicingaddress: string;
  tpinvoicingaddress2: string;
  tpinvoicingcity: string;
  tpinvoicingzipcode: string;
  tprefclient: string;
  tprefsupplier: string;
}

export interface SupplierInvoiceResponse {
  accountingdate: string;
  accountingreference: string;
  clientname: string;
  contractname: string;
  creditnote: string;
  ctreference: string;
  ctrid: number;
  currcode: string;
  deliverydate: string;
  deliveryreference: string;
  mgid: number;
  orderdate: string;
  orderreference: string;
  sicomplevel: boolean;
  sidocdate: string;
  sidocreference: string;
  sidueamount: number;
  sigrosstotal: number;
  siid: number;
  siidcreditnote: number;
  simultiplecontracts: boolean;
  sinettotal: number;
  sipaymentdate: string;
  sipaymentdelaycode: string;
  sipaymentmode: string;
  sireference: string;
  sistatus: string;
  sistatusdate: string;
  sitaxtotal: number;
  sitype: string;
  sitypelabel: string;
  statuslabel: string;
  suppInvoiceLines: Array<SuppInvoiceLineResponse>;
  suppInvoiceSchedules: Array<SuppInvoiceScheduleResponse>;
  suppliername: string;
  tpdeliveryaddress: string;
  tpdeliveryaddress2: string;
  tpdeliverycity: string;
  tpdeliveryzipcode: string;
  tpidclient: number;
  tpidsupplier: number;
  tpinvoicingaddress: string;
  tpinvoicingaddress2: string;
  tpinvoicingcity: string;
  tpinvoicingzipcode: string;
  tprefclient: string;
  tprefsupplier: string;
  refinvoicecreditnote: string;
}
export interface SIfilesResponse {
  cipaystatus: string;
  creationdate: string;
  currcode: string;
  enddate: string;
  jobid: number;
  mgname: string;
  mgid: number;
  servcode: string;
  servlabel: string;
  sfid: number;
  sfstatus: string;
  sftotalgrossamount: number;
  sftotallines: number;
  sftotalnetamount: number;
  sftotaltaxamount: number;
  siid: number;
  startdate: string;
  taxcode: string;
  tpidsupplier: number;
  useridcreation: number;
}

export interface FindSIByAnyRefOrStatusOrDateParams {
  clientname: string;
  ctrreference: string;
  datemax: string;
  datemin: string;
  deliveryreference: string;
  mgid: number;
  orderreference: string;
  paystatus: string;
  sidocreference: string;
  sireference: string;
  sistatus: string;
  sistatus1: string;
  sistatus2: string;
  suppliername: string;
  tprefclient: string;
  tprefsupplier: string;
}

/**
 * @tags Supplier Invoice Controller
 * @summary findSIByAnyRefOrStatusOrDate
 */
export function findSIByAnyRefOrStatusOrDate(
  params: FindSIByAnyRefOrStatusOrDateParams
) {
  return request.get<AbstractResponse<object, SIListResponse>>(
    `${URL}/api/supplierInvoice` +
      prepareQueryParams({
        clientname: params.clientname,
        ctrreference: params.ctrreference,
        datemax: params.datemax,
        datemin: params.datemin,
        deliveryreference: params.deliveryreference,
        mgid: params.mgid,
        orderreference: params.orderreference,
        paystatus: params.paystatus,
        sidocreference: params.sidocreference,
        sireference: params.sireference,
        sistatus1: params.sistatus,
        sistatus2: params.sistatus,
        suppliername: params.suppliername,
        tprefclient: params.tprefclient,
        tprefsupplier: params.tprefsupplier,
      } as any)
  );
}

export interface CreateSupplierInvoiceParams {
  supplierInvoiceRequest: SupplierInvoiceRequest;
}

/**
 * @tags Supplier Invoice Controller
 * @summary createSupplierInvoice
 */
export function createSupplierInvoice(params: CreateSupplierInvoiceParams) {
  return request.post<AbstractResponse<SupplierInvoiceResponse, object>>(
    `${URL}/api/supplierInvoice`,
    params.supplierInvoiceRequest
  );
}

export interface FindSISByAnyRefOrStatusOrDateParams {
  clientname: string;
  ctrreference: string;
  datemax: string;
  datemin: string;
  deliveryreference: string;
  mgid: number;
  orderreference: string;
  paystatus: string;
  sidocreference: string;
  sireference: string;
  sisstatus1: string;
  sisstatus2: string;
  sistype: string;
  suppliername: string;
  tprefclient: string;
  tprefsupplier: string;
  tpid: number;
  currcode: string;
}

/**
 * @tags Supplier Invoice Controller
 * @summary findSISByAnyRefOrStatusOrDate
 */
export function findSISByAnyRefOrStatusOrDate(
  params: FindSISByAnyRefOrStatusOrDateParams
) {
  return request.get<AbstractResponse<object, SIScheduleListResponse>>(
    `${URL}/api/supplierInvoice/schedule` +
      prepareQueryParams({
        clientname: params.clientname,
        ctrreference: params.ctrreference,
        datemax: params.datemax,
        datemin: params.datemin,
        deliveryreference: params.deliveryreference,
        mgid: params.mgid,
        orderreference: params.orderreference,
        paystatus: params.paystatus,
        sidocreference: params.sidocreference,
        sireference: params.sireference,
        sisstatus1: params.sisstatus1,
        sisstatus2: params.sisstatus2,
        sistype: params.sistype,
        suppliername: params.suppliername,
        tprefclient: params.tprefclient,
        tprefsupplier: params.tprefsupplier,
        tpid: params.tpid,
        currcode: params.currcode,
      } as any)
  );
}

export interface GetSupplierInvoiceByIdParams {
  siid: number;
}

/**
 * @tags Supplier Invoice Controller
 * @summary getSupplierInvoiceById
 */
export function getSupplierInvoiceById(params: GetSupplierInvoiceByIdParams) {
  return request.get<AbstractResponse<SupplierInvoiceResponse, object>>(
    `${URL}/api/supplierInvoice/${params.siid}`
  );
}

export interface UpdateSupplierInvoiceParams {
  siid: number;
  supplierInvoiceRequest: SupplierInvoiceRequest;
}

/**
 * @tags Supplier Invoice Controller
 * @summary updateSupplierInvoice
 */
export function updateSupplierInvoice(params: UpdateSupplierInvoiceParams) {
  return request.put<AbstractResponse<SupplierInvoiceResponse, object>>(
    `${URL}/api/supplierInvoice/${params.siid}`,
    params.supplierInvoiceRequest
  );
}

export interface GenerateCreditNoteSIParams {
  sidocreference: string;
  siid: number;
}

/**
 * @tags Supplier Invoice Controller
 * @summary generateCreditNoteSI
 */
export function generateCreditNoteSI(params: GenerateCreditNoteSIParams) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/supplierInvoice/${params.siid}/creditNote/${params.sidocreference}`
  );
}

export interface UpdateSupplierInvoiceStatusParams {
  siid: number;
  sistatus: string;
}

/**
 * @tags Supplier Invoice Controller
 * @summary updateSupplierInvoiceStatus
 */
export function updateSupplierInvoiceStatus(
  params: UpdateSupplierInvoiceStatusParams
) {
  return request.put<AbstractResponse<SupplierInvoiceResponse, object>>(
    `${URL}/api/supplierInvoice/${params.siid}/updateStatus/${params.sistatus}`
  );
}

/**
 * @tags Supplier Invoice Controller
 * @summary getListXmlFile
 */
export function getListXmlFile() {
  return request.get<AbstractResponse<object, string>>(
    `${URL}/api/evollis/XmlList`
  );
}

export interface JobExecutionResponse {
  code: string;
  description: string;
  errorfile: string;
  jobid: number;
  logfile: string;
  message: string;
  outputfile: string;
  servicename: string;
}

export interface loadFilesToSASParams {
  MODE: string;
  Loadflag: string;
  fileNames: Array<any>;
}

/**
 * @tags Supplier Invoice Controller
 * @summary loadFilesToSAS
 */
export function loadFilesToSAS(params: loadFilesToSASParams) {
  return request.post<JobExecutionResponse>(
    `${URL}/api/evollis/loadFilesToSAS/` +
      prepareQueryParams({ Loadflag: params.Loadflag, MODE: params.MODE }),
    params.fileNames
  );
}

export interface FindSIByAnyRefOrStatusParams {
  clientname: string;
  ctrreference: string;
  mgid: number;
  orderreference: string;
  sidocreference: string;
  sireference: string;
  suppliername: string;
  tprefclient: string;
  tprefsupplier: string;
  filename: string;
  sistatus: string;
}

/**
 * @tags Supplier Invoice Saas Controller
 * @summary findSIByAnyRefOrStatus
 */
export function findSIByAnyRefOrStatus(params: FindSIByAnyRefOrStatusParams) {
  return request.get<AbstractResponse<object, SISAASListResponse>>(
    `${URL}/api/evollis/SASList` +
      prepareQueryParams({
        clientname: params.clientname,
        ctrreference: params.ctrreference,
        mgid: params.mgid,
        orderreference: params.orderreference,
        sidocreference: params.sidocreference,
        sireference: params.sireference,
        suppliername: params.suppliername,
        tprefclient: params.tprefclient,
        tprefsupplier: params.tprefsupplier,
        filename: params.tprefsupplier,
        sistatus: params.sistatus,
      } as any)
  );
}
export interface getSIfilesByCriteriaParams {
  currcode: string;
  duedate: string;
  servcode: string;
  sfStatus: string;
  tpidsupplier: number;
  mgid?:number;
}

/**
 * @tags Supplier Invoice Controller
 * @summary getSIfilesByCriteria
 */
export function getSIfilesByCriteria(params: getSIfilesByCriteriaParams) {
  return request.get<AbstractResponse<object, SIfilesResponse>>(
    `${URL}/api/supplierInvoice/getSIfilesByCriteria` +
      prepareQueryParams({
        currcode: params.currcode,
        duedate: params.duedate,
        servcode: params.servcode,
        sfStatus: params.sfStatus,
        tpidsupplier: params.tpidsupplier,
        mgid: params.mgid,
      } as any)
  );
}

export interface SISAASListResponse {
  accountingdate: string;
  accountingreference: string;
  clientname: string;
  contractname: string;
  creditnote: string;
  ctreference: string;
  ctrid: number;
  currcode: string;
  deliverydate: string;
  deliveryreference: string;
  filename: string;
  jobid: number;
  last_action: number;
  mgid: number;
  orderdate: string;
  orderreference: string;
  rapprochementmessage: string;
  sassuppInvoiceLines?: Array<SassuppInvoiceLinesEntity>;
  sassuppInvoiceSchedules?: Array<SassuppInvoiceSchedulesEntity>;
  sicomplevel: boolean;
  sidocdate: string;
  sidocreference: string;
  sidueamount: number;
  sigrosstotal: number;
  siid: number;
  siidcreditnote: number;
  simultiplecontracts: boolean;
  sinettotal: number;
  sipaymentdate: string;
  sipaymentdelaycode: string;
  sipaymentmode: string;
  sireference: string;
  sistatus: string;
  sistatusdate: string;
  sitaxtotal: number;
  sitype: string;
  statuslabel: string;
  suppliername: string;
  tpdeliveryaddress: string;
  tpdeliveryaddress2: string;
  tpdeliverycity: string;
  tpdeliveryzipcode: string;
  tpidclient: number;
  tpidsupplier: number;
  tpinvoicingaddress: string;
  tpinvoicingaddress2: string;
  tpinvoicingcity: string;
  tpinvoicingzipcode: string;
  tprefclient: string;
  tprefsupplier: string;
  assetdescription?: string;
}
export interface SassuppInvoiceLinesEntity {
  assetid: number;
  compid: number;
  ctrid: number;
  siid: number;
  silcategory: string;
  sildescription: string;
  sildescription2: string;
  sildiscountperc: number;
  silgrosstotalamount: number;
  silid: number;
  silnettotalamount: number;
  silnetunitamountafterd: number;
  silnetunitmount: number;
  silorder: number;
  silquantity: number;
  siltaxcode: string;
  siltaxrate: number;
  siltaxtotalamount: number;
  siltype: string;
}
export interface SassuppInvoiceSchedulesEntity {
  mgbankaccount: number;
  siid: number;
  sisamount: number;
  siscategory: string;
  sisdueamount: number;
  sisduedate: string;
  sisid: number;
  sislabel: string;
  sisorder: number;
  sispaymentdelaycode: string;
  sispaymentmode: string;
  sispercentage: number;
  sisstatus: string;
  sistype: string;
  tpbeneficiarybankaccount: string;
  tpidbeneficiary: number;
}

export interface SupplierInvoiceSASResponse {
  accountingdate: string;
  accountingreference: string;
  clientname: string;
  contractname: string;
  creditnote: string;
  ctreference: string;
  ctrid: number;
  currcode: string;
  deliverydate: string;
  deliveryreference: string;
  filename: string;
  jobid: number;
  last_action: number;
  mgid: number;
  orderdate: string;
  orderreference: string;
  rapprochementmessage: string;
  sassuppInvoiceLines?: Array<SassuppInvoiceLine>;
  sassuppInvoiceSchedules?: Array<SassuppInvoiceSchedule>;
  sicomplevel: boolean;
  sidocdate: string;
  sidocreference: string;
  sidueamount: number;
  sigrosstotal: number;
  siid: number;
  siidcreditnote: number;
  simultiplecontracts: boolean;
  sinettotal: number;
  sipaymentdate: string;
  sipaymentdelaycode: string;
  sipaymentmode: string;
  sireference: string;
  sistatus: string;
  sistatusdate: string;
  sitaxtotal: number;
  sitype: string;
  statuslabel: string;
  suppliername: string;
  tpdeliveryaddress: string;
  tpdeliveryaddress2: string;
  tpdeliverycity: string;
  tpdeliveryzipcode: string;
  tpidclient: number;
  tpidsupplier: number;
  tpinvoicingaddress: string;
  tpinvoicingaddress2: string;
  tpinvoicingcity: string;
  tpinvoicingzipcode: string;
  tprefclient: string;
  tprefsupplier: string;
}

export interface SassuppInvoiceLine {
  assetid: number;
  compid: number;
  ctrid: number;
  siid: number;
  silcategory: string;
  sildescription: string;
  sildescription2: string;
  sildiscountperc: number;
  silgrosstotalamount: number;
  silid: number;
  silnettotalamount: number;
  silnetunitamountafterd: number;
  silnetunitmount: number;
  silorder: number;
  silquantity: number;
  siltaxcode: string;
  siltaxrate: number;
  siltaxtotalamount: number;
  siltype: string;
}

export interface SassuppInvoiceSchedule {
  mgbankaccount: number;
  siid: number;
  sisamount: number;
  siscategory: string;
  sisdueamount: number;
  sisduedate: string;
  sisid: number;
  sislabel: string;
  sisorder: number;
  sispaymentdelaycode: string;
  sispaymentmode: string;
  sispercentage: number;
  sisstatus: string;
  sistype: string;
  tpbeneficiarybankaccount: string;
  tpidbeneficiary: number;
}

export interface GetSASSupplierInvoiceByIdParams {
  siid: number;
}

/**
 * @tags Supplier Invoice Controller
 * @summary getSupplierInvoiceById
 */
export function getSASSupplierInvoiceById(
  params: GetSASSupplierInvoiceByIdParams
) {
  return request.get<AbstractResponse<SupplierInvoiceSASResponse, object>>(
    `${URL}/api/evollis/SAS/${params.siid}`
  );
}

export interface UpdateSASSupplierInvoiceParams {
  supplierInvoiceRequest: SupplierInvoiceRequest;
}

/**
 * @tags Supplier Invoice Controller
 * @summary updateSupplierInvoice
 */
export function updateSASSupplierInvoice(
  params: UpdateSASSupplierInvoiceParams
) {
  return request.put<AbstractResponse<SupplierInvoiceResponse, object>>(
    `${URL}/api/evollis/updateSAS`,
    params.supplierInvoiceRequest
  );
}

export interface RapprochementSASSupplierInvoiceParams {
  force: string;
  siid: number;
  Loadflag: string;
}

/**
 * @tags Supplier Invoice Controller
 * @summary updateSupplierInvoice
 */
export function rapprochementSASSupplierInvoice(
  params: RapprochementSASSupplierInvoiceParams
) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/evollis/rapprochement` +
      prepareQueryParams({
        siid: params.siid,
        Loadflag: params.Loadflag,
        force: params.force,
      } as any)
  );
}

export interface downloadFileParams {
  filetype: string;
  jobid: number;
}

/**
 * @tags Supplier Invoice Controller
 * @summary updateSupplierInvoice
 */
export function downloadFile(params: downloadFileParams) {
  return request.get<any>(
    `${URL}/api/job/download` +
      prepareQueryParams({
        filetype: params.filetype,
        jobid: params.jobid,
      } as any)
  );
}

export interface SuppinvoiceFileDetailList {
  assetid: number;
  assetlabel: string;
  assetreference: string;
  ctecategory: string;
  ctedescription: string;
  cteid: number;
  ctetype: string;
  ctetypelabel: string;
  ctreference: string;
  ctrid: number;
  ctsamortizedamount: number;
  ctscategory: string;
  ctsduedate: string;
  ctsenddate: string;
  ctsgrossamount: number;
  ctsid: number;
  ctsinterestamount: number;
  ctsorder: number;
  ctsrentalamount: number;
  ctsstartdate: string;
  ctstaxamount: number;
  ctstaxcode: string;
  priid: number;
  prilabel: string;
  servrepayamount: number;
  servrepayfixedamount: number;
  servrepaygrossamount: number;
  servrepaypercentage: number;
  servrepaytaxamount: number;
  servrepaytaxcode: string;
  servrepaytaxrate: number;
  sfdid: number;
  sfid: number;
  tpidclient: number;
  tpname: string;
}

export interface SuppinvoiceFileDetail {
  cipaystatus: string;
  creationdate: Date;
  currcode: string;
  currcodelabel: string;
  enddate: string;
  jobid: number;
  mgid: number;
  servcode: string;
  sfid: number;
  sfstatus: string;
  sftotalgrossamount: number;
  sftotallines: number;
  sftotalnetamount: number;
  sftotaltaxamount: number;
  siid: number;
  startdate: string;
  suppinvoiceFileDetailList: SuppinvoiceFileDetailList[];
  taxcode: string;
  tpidsupplier: number;
  suppliername: string;
  supplierreference: string;
  useridcreation: number;
}

export interface getSuppInvoiceFileAndDetailByIdParams {
  sfid: number;
}

/**
 * @tags Supplier Invoice Controller
 * @summary getSupplierInvoiceById
 */
export function getSuppInvoiceFileAndDetailById(
  params: getSuppInvoiceFileAndDetailByIdParams
) {
  return request.get<AbstractResponse<SuppinvoiceFileDetail, object>>(
    `${URL}/api/getSupplierInvoiceFileDetailById/${params.sfid}`
  );
}


export interface BatchJobExecution {
  create_time: string;
  end_time: string;
  errorfile: string;
  exit_code: string;
  exit_message: string;
  job_configuration_location: string;
  job_execution_id: number;
  job_instance_id: number;
  last_updated: string;
  logfile: string;
  logfolder: string;
  module: string;
  outputfile: string;
  outputfolder: string;
  serviceexecparam: string;
  servicename: string;
  start_time: string;
  status: string;
  userid: number;
  version: number;
}

export interface GetJobListByCriteriaParams {
  servicename: string;
  startdate: string;
  status: string;
}

/**
 * @tags Batch Job Execution Controller
 * @summary getJobListByCriteria
 */
export function getJobListByCriteriaSupplierInvoice(params: GetJobListByCriteriaParams) {
  return request.get<AbstractResponse<object, BatchJobExecution>>(
    `${URL}/api/job` +
      prepareQueryParams({
        servicename: params.servicename,
        startdate: params.startdate,
        status: params.status,
      } as any)
  );
}

export interface ConformityCheck {
  passed: boolean;
  message: string;
  code: string;
  expectedValue: any;
  actualValue: any;
}

export interface ConformityCheckResults {
  clientExistsCheck: ConformityCheck;
  clientActivityCheck: ConformityCheck;
  dateFactureCheck: ConformityCheck;
  vinNotInvoicedCheck: ConformityCheck;
  rrdiMatchCheck: ConformityCheck;
  familleProductCheck: ConformityCheck;
  montantToleranceCheck: ConformityCheck;
  activiteActiveCheck: ConformityCheck;
  
 
  allChecksPass: boolean;
  failedChecks: Array<string>;
  warnings: Array<string>;
}

export interface ConformityResponse {
  status: string; 
  message: string;
  codeMovement: string;
  numFacture: string;
  vin: string;
  siid?: number; 
  sireference?: string; 
  

  conformityResults: ConformityCheckResults;
  
 
  processedAt: string; 
  jobId?: number;
  filename?: string;
  lineNumber?: number;
  brandLabel?: string;
  familyLabel?: string;
  versionYear?: number;
  versionLabelLocalLong?: string;
  motorisation?: string;
  co2EmissionWLTP?: number;
}

export interface ConformityRequest {
  codeMovement: string; // INVO or CRNO
  typeDocument: string;
  codePays: string; 
  codeMarque: string;
  codeClientFacture: string;
  familleFinancement: string;
  typeVehicule: string; 
  vin: string;
  blvd: string;
  numFacture: string;
  dateEmissionFacture: string; 
  dateDebutCalculInteret: string; 
  dureeFranchise: number;
  codeDevise: string;
  montantHTVehicule: number;
  montantAutresTaxes?: number;
  montantTVA: number;
  montantFrais?: number;
  montantTTC: number;
  jobId?: number;
  filename?: string;
  lineNumber?: number;
  numFactureOrigine?: string;
  forwardedAuthUserId?: string;
  forwardedAuthUsername?: string;
  forwardedAuthMgid?: string;
  originalInvoiceReference?: string;
  brandLabel?: string;
  familyLabel?: string;
  versionLabelLocalLong?: string;
  motorisation?: string;
  co2EmissionWLTP?: string;
  versionYear?: number;
  ctrid?: number;
  ctreference?: string;
isManualProcess?: boolean;
}

export interface ProcessSupplierInvoiceWorkflowParams {
  conformityRequest: ConformityRequest;
}

/**
 * @tags Supplier Invoice Controller
 * @summary processSupplierInvoiceWorkflow
 * @description Performs complete invoice/credit note processing: validates conformity, creates supplier invoice, updates asset information, and activates contract. Handles both INVO and CRNO movement codes.
 */
export function processSupplierInvoiceWorkflow(params: ProcessSupplierInvoiceWorkflowParams) {
  return request.post<AbstractResponse<ConformityResponse, object>>(
    `${URL}/api/v1/supplier-invoice/conformity/contractactivation`,
    params.conformityRequest
  );


  
}

export type InvoiceReferenceByVinResponse = {
  siid?: number
  sireference?: string
  sitype?: string
  sistatus?: string
  tpidsupplier?: number
  mgid?: number
  sidocreference?: string
  sidocdate?: string
  simultiplecontracts?: boolean
  ctrid?: number
  ctreference?: string
  tprefsupplier?: string
  tprefclient?: string
  tpidclient?: number
  tpdeliveryaddress?: string
  tpdeliveryaddress2?: string
  tpdeliveryzipcode?: string
  tpdeliverycity?: string
  tpinvoicingaddress?: string
  tpinvoicingaddress2?: string
  tpinvoicingzipcode?: string
  tpinvoicingcity?: string
  orderreference?: string
  orderdate?: string
  sipaymentdelaycode?: string
  sipaymentdate?: string
  sipaymentmode?: string
  sigrosstotal?: number
  sinettotal?: number
  sitaxtotal?: number
  currcode?: string
  suppliername?: string
  contractname?: string
  clientname?: string
  statuslabel?: string
  creditnote?: string
  sistatusdate?: string
  sidueamount?: number
  accountingreference?: string
  accountingdate?: string
  siidcreditnote?: number
  last_action?: number
  sicomplevel?: boolean
  refinvoicecreditnote?: string
  sitypelabel?: string
  vin1?: string
  vin2?: string
}
